export { Separator, type SeparatorProps } from './Separator';
export {
  SEPARATOR_FILLS,
  SEPARATOR_RADII,
  SEPARATOR_THICKNESSES,
  SEPARATOR_TONES,
  separatorBackgroundClass,
  separatorRadiusClass,
  separatorThicknessClass,
  separatorVariants,
  type SeparatorFill,
  type SeparatorRadius,
  type SeparatorThickness,
  type SeparatorTone,
  type SeparatorVariantProps,
} from './separator.variants';
